import React from "react";
import { Image, Tag } from "antd";

const valueOrDash = (value) => {
  if (value === null || value === undefined || value === "") return "N/A";
  if (typeof value === "object") return JSON.stringify(value, null, 2);
  return String(value);
};

const isImageUrl = (value) => typeof value === "string" && /\.(png|jpe?g|webp|gif)$/i.test(value.split("?")[0]);

const DetailRows = ({ data = {} }) => (
  <div>
    {Object.entries(data).map(([key, value]) => (
      <span key={key}>
        <p>{key.replace(/_/g, " ")}</p>
        {isImageUrl(value) ? (
          <Image src={value} width={140} alt={key.replace(/_/g, " ")} />
        ) : (
          <pre className="modal-list-dark-text">{valueOrDash(value)}</pre>
        )}
      </span>
    ))}
  </div>
);

const KycDetails = ({ data }) => {
  const pendingReviews = data?.kyc_pending_reviews || [];
  const verifiedData = data?.kyc_verified_data || [];
  const identityVerifications = data?.identity_verifications || [];

  return (
    <div className="users-modal-list__container">
      <div>
        <span>
          <p>KYC Status</p>
          <p className="modal-list-dark-text">
            <Tag>{data?.kyc_verified ? "VERIFIED" : "PENDING/UNVERIFIED"}</Tag>
          </p>
        </span>
        <span>
          <p>Tier</p>
          <p className="modal-list-dark-text">{data?.tier || "N/A"}</p>
        </span>
      </div>

      <h4>Pending Reviews</h4>
      {pendingReviews.length ? pendingReviews.map((review) => (
        <DetailRows key={review.id} data={review} />
      )) : <p className="modal-list-dark-text">No pending KYC review.</p>}

      <h4>Verified Data</h4>
      {verifiedData.length ? verifiedData.map((item) => (
        <DetailRows key={item.id} data={item} />
      )) : <p className="modal-list-dark-text">No verified KYC data.</p>}

      <h4>Identity Verifications</h4>
      {identityVerifications.length ? identityVerifications.map((item) => (
        <DetailRows key={item.id || item.identity_number} data={item} />
      )) : <p className="modal-list-dark-text">No identity verification records.</p>}
    </div>
  );
};

export default KycDetails;
